import React, { useEffect, useState } from "react";
import { List } from "@refinedev/antd";
import { useDelete, useNavigation, useResource } from "@refinedev/core";
import { App } from "antd";
import { ListSlots, ModuleListView, TONE_FRAME_CLASS, useListReplacement, useWidePanel } from "@evo-flywheel/ui";
import { resourceBySlug } from "../../kit-resources";
import { panelUse, specs } from "../../specs";
import { GovernancePanel } from "./GovernancePanel";

/** Generated list (UI contract rules 10, 14): the module's slots render above it, or a slot replaces it. */
export const GenericList: React.FC = () => {
  const { resource } = useResource();
  const Replacement = useListReplacement(resource?.name);
  if (Replacement) return <><ListSlots slug={resource?.name} only="actions" /><Replacement slug={resource!.name} /></>;
  return <GeneratedList />;
};

const GeneratedList: React.FC = () => {
  const { resource } = useResource();
  const slug = resource?.name ?? "";
  const meta = resourceBySlug[slug]?.meta;
  const spec = specs[slug];
  const { show, edit } = useNavigation();
  const { mutate: remove } = useDelete();
  const { modal } = App.useApp();

  // Partial vertical panel = selection companion (ADR-013 §2.6): context for the clicked row.
  const companion = panelUse[slug]?.startsWith("partial");
  const { setWidePanelContent } = useWidePanel();
  const [active, setActive] = useState<string | number | undefined>();
  useEffect(() => () => setWidePanelContent(null), [slug, setWidePanelContent]);

  const onCommand = (command: string, record: Record<string, unknown>) => {
    const id = record.id as string;
    if (command === "edit") edit(slug, id);
    if (command === "delete") {
      modal.confirm({
        title: `Eliminare questo record di ${meta?.label ?? slug}?`,
        okText: "Elimina", okButtonProps: { danger: true }, cancelText: "Annulla",
        onOk: () => remove({ resource: slug, id }),
      });
    }
  };

  return <>
    <ListSlots slug={slug} />
    <List wrapperProps={{ className: TONE_FRAME_CLASS }} canCreate={spec?.writePosture === "crud"}>
      {spec && (
        <ModuleListView
          resource={slug}
          spec={spec}
          syncWithLocation
          onDrill={(id) => show(slug, id as string)}
          onCommand={onCommand}
          activeRowKey={active}
          onRowClick={companion ? (record) => {
            setActive(record.id as string);
            setWidePanelContent(<GovernancePanel meta={meta} record={record} />);
          } : undefined}
        />
      )}
    </List>
  </>;
};
